<template>
  <button class="btn secondary">
    <slot name="icon"></slot>
    <slot></slot>
    <svg
      v-if="unfolded !== null"
      :class="[unfolded ? 'unfolded' : '']"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 20 20"
    >
      <path d="M6.666 7.584a.75.75 0 0 0-.53.219.75.75 0 0 0 0 1.06l3.335 3.334a.75.75 0 0 0 1.06 0l3.332-3.334a.75.75 0 0 0 0-1.06.75.75 0 0 0-1.06 0L10 10.605 7.197 7.803a.75.75 0 0 0-.531-.219z"/>
    </svg>
    <slot name="lastIcon"></slot>
  </button>
</template>

<script>
export default {
  name: 'buttonPrimary',
  props: {
    unfolded: {
      type: Boolean,
      optional: true,
      default: null,
    },
  },
}
</script>

<style lang="scss">
  .btn.secondary {
    height: 48px;
    padding: 0 18px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    column-gap: 8px;
    background: var(--Basic-White);
    border: 1px solid var(--Secondary-Button-Stroke);
    border-radius: 8px;
    white-space: nowrap;

    color: var(--Primary-Shades-Primary);
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;

    transition: all ease-in-out 300ms;

    svg {
      width: 20px;
      height: 20px;
      fill: var(--Primary-Shades-Primary);
      transform: scaleY(1);
      transition: transfrorm ease-in-out 300ms;

      &.unfolded {
        transform: scaleY(-1);
      }
    }

    &:hover {
      border-color: var(--primary);
    }

    &:active {
      border-color: var(--primary);
      background: var(--Surface);
    }

    &:disabled {
      background: var(--Basic-White);
      color: var(--Button-States-Disabled_Txt);
      border-color: var(--Secondary-Button-Stroke);
      opacity: 1 !important;

      svg {
        fill: var(--Button-States-Disabled_Txt);
      }
    }

    &.small {
      height: 40px;
      padding: 0 16px;

      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
    }
  }
</style>
